import AppStore from "./appStore.js";
const appStore = new AppStore();

const stores = {
  appStore,
};
/// 默认导出接口
export default stores;
